import { instance as axios } from "../axios";
import JWT from "jsonwebtoken";
import * as d3 from "d3";

const TABLE = "/proposta/";

const calcActions = ({ reportadas, total }) => {
  //return reportadas + "/" + total;
  try {
    const _total = reportadas > total ? reportadas : total;
    return reportadas + "/" + _total;
  } catch (error) {
    return reportadas + "/" + total;
  }
};

// initial state
const state = {
  data: [],
  stats: {
    objetivo: [],
    medida: [],
    acao: [],
  },
};

// getters
const getters = {
  getAll: (state) => {
    return state.data.filter((el) => {
      return el.data_criacao;
    });
  },

  getPropostas: (state) => {
    return state.data.filter((el) => {
      return !el.data_criacao;
    });
  },

  getLivresAno: (state) => (id, acao, instituicao) => {
    if (!id || !acao || !instituicao) return;
    var array = state.data.filter((el) => {
      return (
        !el.data_criacao &&
        el.id_ano == id &&
        el.id_acao == acao &&
        el.id_instituicao == instituicao
      );
    });

    return typeof array == "undefined" || array.length == 0
      ? null
      : array[0].id_proposta;
  },

  getAcoesByInstituicao: (state) => (id, acao, instituicao) => {
    if (!id || !acao || !instituicao) return;

    var array = state.data.filter((el) => {
      return (
        !el.data_criacao &&
        el.id_ano == id &&
        el.id_acao == acao &&
        el.id_instituicao == instituicao &&
        el.submetida == 0 &&
        el.reporte == 0
      );
    });

    return typeof array == "undefined" || array.length == 0 ? null : array;
  },

  getStats: (state) => {
    return state.stats;
  },

  getObjetivoAno: (state) => (i, a, o) => {
    if (!i || !a || !o) return;

    var obj = state.stats.objetivo.find((el) => {
      var k = el.key.split("-");
      return Number(k[0]) == i && Number(k[1]) == a && Number(k[2]) == o;
    });

    if (typeof obj != "undefined")
      return obj.value.total > 0 ? calcActions(obj.value) : "-";
    else return "-";
  },

  getMedidaAno: (state) => (i, a, m) => {
    if (!i || !a || !m) return;

    var obj = state.stats.medida.find((el) => {
      var k = el.key.split("-");
      return Number(k[0]) == i && Number(k[1]) == a && Number(k[2]) == m;
    });

    if (typeof obj != "undefined")
      return obj.value.total > 0 ? calcActions(obj.value) : "-";
    else return "-";
  },

  getAcaoAno: (state) => (i, a, ac, tipo) => {
    if (!i || !a || !ac) return;

    var obj = state.stats.acao.find((el) => {
      var k = el.key.split("-");
      return (
        Number(k[0]) == i &&
        Number(k[1]) == a &&
        Number(k[2]) == ac &&
        Number(k[3]) == tipo
      );
    });

    if (typeof obj != "undefined")
      return obj.value.total > 0 ? calcActions(obj.value) : "-";
    else return "-";
  },

  getById: (state) => (id) => {
    if (!id) return;
    return state.data.find((el) => {
      return el.id_proposta == id;
    });
  },
};

// actions
const actions = {
  get({ commit, dispatch }, submetida = 1) {
    return axios
      .get(TABLE + "tipo/" + submetida)
      .then((res) => {
        if (res.data.data.length > 0) {
          if (submetida == 1) {
            commit("setData", res.data.data);
            //dispatch("get", 0);
          } else if (submetida == 0) {
            commit("updateData", res.data.data);
          }
        } else commit("setData", null);
        /*decode(res.data.data).then((r)=>{
                    if(r) {
                        if(submetida == 1){
                            commit('setData', r);
                            dispatch('get', 0);
                        }
                        else if(submetida == 0) {
                            commit('updateData', r);
                        }
                    }
                    else commit('setData', null)
                }); */
      })
      .catch((err) => {
        commit("setData", null);
      });
  },

  getByInstituicao({ commit }, id) {
    return axios
      .get(TABLE + "params/" + id)
      .then((res) => {
        commit("setData", res.data.data || null);
      })
      .catch((err) => {
        commit("setData", null);
      });
  },

  insert({ dispatch, rootState }, params) {
    return axios
      .post(TABLE, { ...params })
      .then((res) => {
        if (!res.data.errors) {
          if (rootState.session.user.super == 0)
            dispatch("getByInstituicao", rootState.session.user.id_instituicao);
          else dispatch("get");

          return true;
        } else return false;
      })
      .catch((err) => {
        return false;
      });
  },

  export({ dispatch }, params) {
    return axios
      .post(TABLE + "exportar/", { ...params })
      .then((res) => {
        if (!res.data.errors) return true;
        else return false;
      })
      .catch((err) => {
        return false;
      });
  },

  add({ dispatch, rootState }, params) {
    return axios
      .post(TABLE + "add/", { ...params })
      .then((res) => {
        if (!res.data.errors) {
          if (rootState.session.user.super == 0)
            dispatch("getByInstituicao", rootState.session.user.id_instituicao);
          else dispatch("get");

          return true;
        } else return false;
      })
      .catch((err) => {
        return false;
      });
  },

  clonar({ dispatch, rootState }, params) {
    return axios
      .post(TABLE + "clonar/", { ...params })
      .then((res) => {
        if (!res.data.errors) {
          if (rootState.session.user.super == 0)
            dispatch("getByInstituicao", rootState.session.user.id_instituicao);
          else dispatch("get");

          return true;
        } else return false;
      })
      .catch((err) => {
        return false;
      });
  },

  remove({ dispatch, rootState }, params) {
    return axios
      .post(TABLE + "remove/", { ...params })
      .then((res) => {
        if (!res.data.errors) {
          if (rootState.session.user.super == 0)
            dispatch("getByInstituicao", rootState.session.user.id_instituicao);
          else dispatch("get");

          return true;
        } else return false;
      })
      .catch((err) => {
        return false;
      });
  },

  reporte({ dispatch, rootState }, params) {
    return axios
      .post(TABLE + "reporte/", { ...params })
      .then((res) => {
        if (!res.data.errors) {
          if (rootState.session.user.super == 0)
            dispatch("getByInstituicao", rootState.session.user.id_instituicao);
          else dispatch("get");

          return true;
        } else return false;
      })
      .catch((err) => {
        return false;
      });
  },

  update({ dispatch, rootState }, params) {
    return axios
      .put(TABLE, { ...params })
      .then((res) => {
        if (!res.data.errors) {
          if (rootState.session.user.super == 0)
            dispatch("getByInstituicao", rootState.session.user.id_instituicao);
          else dispatch("get");

          return true;
        } else return false;
      })
      .catch((err) => {
        return false;
      });
  },

  reverter_reporte({ dispatch, rootState }, params) {
    return axios
      .put(TABLE + "reverter-reporte/", { ...params })
      .then((res) => {
        if (!res.data.errors) {
          if (rootState.session.user.super == 0)
            dispatch("getByInstituicao", rootState.session.user.id_instituicao);
          else dispatch("get");

          return true;
        } else return false;
      })
      .catch((err) => {
        return false;
      });
  },
  reverter_submissao({ dispatch, rootState }, params) {
    return axios
      .put(TABLE + "reverter-submissao/", { ...params })
      .then((res) => {
        if (!res.data.errors) {
          if (rootState.session.user.super == 0)
            dispatch("getByInstituicao", rootState.session.user.id_instituicao);
          else dispatch("get");

          return true;
        } else return false;
      })
      .catch((err) => {
        return false;
      });
  },

  delete({ dispatch, rootState }, { id }) {
    return axios
      .delete(TABLE + id)
      .then((res) => {
        if (!res.data.errors) {
          if (rootState.session.user.super == 0)
            dispatch("getByInstituicao", rootState.session.user.id_instituicao);
          else dispatch("get");

          return true;
        } else return false;
      })
      .catch((err) => {
        return false;
      });
  },
};

// mutations
const mutations = {
  setData(state, data) {
    state.data = data ? data : [];

    if (data) state.stats.acao = StatPerAcao(data);
  },
  updateData(state, data) {
    if (data) {
      state.data = state.data.concat(data);
      state.stats.acao = state.stats.acao.concat(StatPerAcao(data));
    }
  },
};

function StatPerAcao(array) {
  var value = d3
    .nest()
    .key((d) => {
      return (
        d.id_instituicao +
        "-" +
        d.id_ano +
        "-" +
        d.id_acao +
        "-" +
        d.auto_proposta
      );
    })
    .rollup((v) => {
      return {
        total: v.length,
        reportadas: d3.sum(v, function(d) {
          return d.reporte;
        }),
      };
    })
    .entries(array);
  return value;
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/propostas.js